<template>
	<div>
		

		<b-row class="mt-5">
			<b-col md="4">
				<b-form inline @submit.prevent="searchRoutePlans">
					<b-form-group>
						<b-input type="text" v-model="currentSearch" />

						<b-button type="submit" variant="outline-success">Search</b-button>

						<b-button v-if="searchFlag" @click.prevent="clearSearch" variant="outline-danger">Clear</b-button>
					</b-form-group>
				</b-form>
			</b-col>

			<b-col>
				<b-link :to="{ name: 'routeplancreate' }" class="float-right mb-3" title="Add a new Route Plan">
					<b-icon font-scale="1.5" icon="plus-square"></b-icon>
				</b-link>
			</b-col>
		</b-row>

		<b-row class="mt-1">
			<b-col md="12">
				<b-table-simple bordered>
					<b-thead head-variant="light">
						<tr>
							<th style="width: 250px">
								<a href="#" @click.prevent="sort('Name')">
									Engineer
									<b-icon font-scale="1.5" class="ml-3" v-if="currentSort == 'FullName' && currentSortDir == 'asc'" icon="chevron-compact-up"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else-if="currentSort == 'FullName' && currentSortDir == 'desc'" icon="chevron-compact-down"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon>
								</a>
							</th>
							<th style="width: 160px">
								<a href="#" @click.prevent="sort('startDate')">
									Start Date
									<b-icon font-scale="1.5" class="ml-3" v-if="currentSort == 'startDate' && currentSortDir == 'asc'" icon="chevron-compact-up"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else-if="currentSort == 'startDate' && currentSortDir == 'desc'" icon="chevron-compact-down"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon>
								</a>
							</th>
							<th style="width: 160px">
								<a href="#" @click.prevent="sort('Added')">
									Added
									<b-icon font-scale="1.5" class="ml-3" v-if="currentSort == 'Added' && currentSortDir == 'asc'" icon="chevron-compact-up"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else-if="currentSort == 'Added' && currentSortDir == 'desc'" icon="chevron-compact-down"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon>
								</a>
							</th>
							<th style="width: 160px">
								<a href="#" @click.prevent="sort('Updated')">
									Updated
									<b-icon font-scale="1.5" class="ml-3" v-if="currentSort == 'Updated' && currentSortDir == 'asc'" icon="chevron-compact-up"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else-if="currentSort == 'Updated' && currentSortDir == 'desc'" icon="chevron-compact-down"></b-icon>
									<b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon>
								</a>
							</th>
							<th style="width: 60px">Conf</th>
							<th style="">Stops</th>
							<th style="width: 160px"></th>
						</tr>
					</b-thead>
					<b-tbody>
						<route-plan-list-row v-for="routeplan in sortedRoutePlans" :key="routeplan.Id" :routeplan="routeplan" @update="updateRoutePlan" @view="viewRoutePlan" @print="printRoutePlan" />
					</b-tbody>
				</b-table-simple>
			</b-col>
		</b-row>

		<!-- <b-row class="mt-3">
			
			<b-col cols="4" offset="4">			
				<b-pagination first-number last-number v-model="paging.currentPage" :total-rows="paging.totalCount" :per-page="paging.pageSize"  @input="fetchRoutePlans" limit="6" align="fill"></b-pagination> 
			</b-col>

			<b-col cols="1">
				<b-form-input debounce="1000" min="1" v-model="paging.currentPage" :max="paging.totalPages" type="number"  @input="fetchRoutePlans"></b-form-input>				
			</b-col>
		</b-row> -->

		<div class="d-flex justify-content-center mb-5">
			<b-pagination
				first-number
				last-number
				v-model="paging.currentPage"
				:total-rows="paging.totalCount"
				:per-page="paging.pageSize"
				@input="fetchRoutePlans"
				limit="7"
				class="mr-3"
			></b-pagination> 
			<b-form-input
				debounce="1000"
				min="1"
				v-model="paging.currentPage"
				:max="paging.totalPages"
				type="number"
				@input="fetchRoutePlans"
				style="width:100px;"
			></b-form-input>
		</div>
		
	</div>
</template>

<script>
import RoutePlanService from '@/api-services/routeplan.service';
import RoutePlanListRow from '@/components/routeplan/routeplan-list-row';

export default {
	name: 'RoutePlanList',

	components: {
		RoutePlanListRow
	},

	data() {
		return {
			routeplans: [],
			selectedRoutePlanId: null,

			currentSort: 'Added',
			currentSortDir: 'desc',

			currentSearch: '',
			searchFlag: false,

			paging: {
				currentPage: 1,
				pageSize: 50,
				totalCount: 0,
				totalPages: 0
			}
		};
	},

	computed: {
		sortedRoutePlans() {
			var sortedRoutePlans = this.routeplans.slice().sort((a, b) => {
				let modifier = 1;
				if (this.currentSortDir === 'desc') modifier = -1;
				if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
				if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
				return 0;
			});

			return sortedRoutePlans;
		}
	},

	created() {
		this.fetchRoutePlans();
	},

	methods: {
		sort(s) {
			//if s == current sort, reverse
			if (s === this.currentSort) {
				this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = s;

			this.fetchRoutePlans();
		},

		updateRoutePlan(routePlanId) {
			this.$router.push({
				name: 'routeplanupdate',
				params: { id: routePlanId }
			});
		},

		viewRoutePlan(routePlanId) {
			this.$router.push({
				name: 'routeplanview',
				params: { id: routePlanId }
			});
		},

		printRoutePlan(routePlanId) {
			this.$router.push({
				name: 'routeplanprint',
				params: { id: routePlanId }
			});
		},

		resetPaging() {
			this.paging = {
				currentPage: 1,
				pageSize: 50,
				totalCount: 0,
				totalPages: 0
			};
		},

		clearSearch() {
			if (this.searchFlag) {
				this.currentSearch = '';
				this.searchFlag = false;
				this.resetPaging();
				this.fetchRoutePlans();
			}
		},

		searchRoutePlans() {
			if (this.currentSearch != '') {
				this.resetPaging();

				RoutePlanService.search(this.currentSearch).then((response) => {
					Object.assign(this.paging, JSON.parse(response.headers['paging-headers']));

					this.routeplans = response.data;
					this.searchFlag = true;
				});
			}
		},

		fetchRoutePlans() {
			RoutePlanService.getPaged(this.paging.pageSize, this.paging.currentPage, this.currentSort, this.currentSortDir)
				.then((response) => {
					Object.assign(this.paging, JSON.parse(response.headers['paging-headers']));

					this.routeplans = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/routeplan/routeplan-list.vue